import React from "react";
import { Row } from "react-material-responsive-grid";
import { AppEnv } from "../../env";
import Section from "../Section";

const moment = require("moment/moment");
require("moment/locale/es");
moment.locale("es");

const Contact = (props) => {
  const { id, image, text, action } = props;
  return (
    <Row
      id={id}
      className="centerV uk-width-1-1"
      style={{
        margin: 0,
        padding: "5px 0",
      }}
    >
      <img alt="" className="lazyload" data-src={image} />
      <label className="normal_text" style={{ marginLeft: 5 }}>
        <a style={{ color: AppEnv.fourthColor }} href={action}>
          {text}
        </a>
      </label>
    </Row>
  );
};
const Office = (props) => {
  const { id, image, title, text } = props;
  return (
    <Row
      id={id}
      className="centerV uk-width-1-1"
      style={{
        margin: 0,
        padding: "5px 0",
      }}
    >
      <Row
        className=" uk-width-1-6"
        style={{
          margin: 0,
          padding: 0,
        }}
      >
        <img alt="" className="lazyload" data-src={image} />
      </Row>
      <Row
        className=" uk-width-5-6"
        style={{
          margin: 0,
          padding: 0,
        }}
      >
        <Row
          className=" uk-width-1-1"
          style={{
            margin: 0,
            padding: 0,
          }}
        >
          <label
            className="normal_text uk-width-1-1"
            style={{ textAlign: "left", color: AppEnv.fourthColor }}
          >
            {title}
          </label>
        </Row>
        <Row
          className=" uk-width-1-1"
          style={{
            margin: 0,
            padding: 0,
          }}
        >
          <label
            className="normal_text uk-width-1-1"
            style={{ textAlign: "left", color: AppEnv.fourthColor }}
          >
            {text}
          </label>
        </Row>
      </Row>
    </Row>
  );
};

const About = (props) => {
  const { id, image, text } = props;
  return (
    <Row
      id={id}
      className="centerV uk-width-1-1"
      style={{
        margin: 0,
        padding: "5px 0",
      }}
    >
      <img alt="" className="lazyload" data-src={image} />
      <label
        className="normal_text"
        style={{ marginLeft: 5, color: AppEnv.fourthColor }}
      >
        {text}
      </label>
    </Row>
  );
};

const Allay = (props) => {
  const { id, image, text, action } = props;
  return (
    <Row
      id={id}
      className="centerV uk-width-1-1"
      style={{
        margin: 0,
        padding: "5px 0",
      }}
    >
      <img alt="" className="lazyload" data-src={image} />
      <label
        className="normal_text"
        style={{ marginLeft: 5, color: AppEnv.fourthColor }}
      >
        <a
          style={{ color: AppEnv.fourthColor }}
          href={action}
          target={"_blank"}
        >
          {text}
        </a>
      </label>
    </Row>
  );
};

const Platform = (props) => {
  const { id, image, action } = props;
  return (
    <Row
      id={id}
      className="centerAll uk-width-1-6@m uk-width-1-4"
      style={{
        margin: 0,
        padding: "5px",
      }}
    >
      <Row
        style={{
          margin: 0,
          borderRadius: 6,
          backgroundColor:
            image === "../images/aws.png" ? AppEnv.fourthColor : null,
          padding: image === "../images/aws.png" ? 3 : null,
        }}
      >
        <a
          style={{ color: AppEnv.fourthColor }}
          href={action}
          target={"_blank"}
        >
          <img alt="" className="centerAll lazyload" data-src={image} />
        </a>
      </Row>
    </Row>
  );
};

const Social = (props) => {
  const { id, image, action } = props;
  return (
    <Row
      id={id}
      className="centerAll uk-width-1-8"
      style={{ margin: 0, padding: "5px" }}
    >
      <a href={action} target={"_blank"}>
        <i className={image} />
      </a>
    </Row>
  );
};

export default function Footer() {
  const conacts = [
    {
      image: "https://img.icons8.com/color/24/000000/mexico.png",
      text: "800 120 00 58",
      action: "tel:8001200058",
    },
    {
      image: "https://img.icons8.com/color/24/000000/colombia.png",
      text: "322 41 41 38",
      action: "tel:322414138",
    },
    {
      image: "https://img.icons8.com/pastel-glyph/24/ffffff/email--v1.png",
      text: "Contacto",
      action: "mailto:contacto@kolegia.com",
    },
    {
      image: "https://img.icons8.com/pastel-glyph/24/ffffff/email--v1.png",
      text: "Soporte",
      action: "mailto:soporte@kolegia.com",
    },
    {
      image: "https://img.icons8.com/pastel-glyph/24/ffffff/email--v1.png",
      text: "Ventas",
      action: "mailto:ventas@kolegia.com",
    },
  ];

  const offices = [
    {
      image: "https://img.icons8.com/color/24/000000/mexico.png",
      title: "Circuito presidentes",
      text: "S/N, Xalapa, Ver.",
    },
    {
      image: "https://img.icons8.com/color/24/000000/colombia.png",
      title: "Calle 118 #19-52",
      text: "Of. 204-206, Bogotá.",
    },
  ];

  const ous = [
    {
      image: "https://img.icons8.com/android/20/ffffff/about.png",
      text: "Acerca de",
    },
    {
      image: "https://img.icons8.com/ios-filled/20/ffffff/resume.png",
      text: "Vacantes",
    },
    {
      image:
        "https://img.icons8.com/ios-filled/20/ffffff/google-blog-search.png",
      text: "DevBlog",
    },
  ];

  const allies = [
    {
      image: "https://img.icons8.com/ios-filled/20/ffffff/cloud-link.png",
      text: "Rossel Consultores",
      action: "https://www.rosselconsultores.org",
    },
    {
      image: "https://img.icons8.com/ios-filled/20/ffffff/cloud-link.png",
      text: "Red Me Uno",
      action: "https://www.rosselconsultores.org/red-me-uno",
    },
    {
      image: "https://img.icons8.com/ios-filled/20/ffffff/cloud-link.png",
      text: "Escuelas de Perdón",
      action:
        "https://fundacionparalareconciliacion.org/escuelas-de-perdon-y-reconciliacion",
    },
    {
      image: "https://img.icons8.com/ios-filled/20/ffffff/cloud-link.png",
      text: "Fundación Educere",
      action: "https://kolegia.com",
    },
  ];

  const platforms = [
    {
      image: "https://otrasimagenes.s3.amazonaws.com/generales/AppStore.png",
      action: AppEnv.iOS,
    },
    {
      image: "https://otrasimagenes.s3.amazonaws.com/generales/PlayStore.png",
      action: AppEnv.Android,
    },
    {
      image: "../images/AppGallery2.png",
      action: AppEnv.iOS,
    },
    {
      image: "../images/aws.png",
      action: "https://aws.amazon.com",
    },
  ];

  const socialNetworks = [
    {
      action: "https://twitter.com/KolegiaLatam",
      image: "fab fa-twitter fa-2x Color4",
    },
    {
      action: "https://www.facebook.com/Kolegia.latam/",
      image: "fab fa-facebook-f fa-2x Color4",
    },
    {
      action: "mailto:" + AppEnv.correo_soporte,
      image: "far fa-envelope fa-2x Color4",
    },
    {
      action: "https://wa.me/5212282205275",
      image: "fab fa-whatsapp fa-2x Color4",
    },
  ];

  return (
    <Row className="centerAll uk-width-1-1">
      <Section
        scrollspy="none"
        padding={"2vw 2vw 0 2vw"}
        bgColor={AppEnv.oxford1Light}
        imagePosition="none"
      >
        <Row className="centerH uk-width-1-1">
          <Row
            className="uk-width-1-1 centerAll uk-hidden@m"
            style={{ margin: "0 0 20px 0", padding: 0 }}
          >
            <Row
              className="uk-width-1-3"
              style={{ alignItems: "flex-start", alignContent: "flex-start" }}
            >
              <img
                style={{ objectFit: "contain" }}
                alt=""
                className="imagenl lazyload uk-width-1-1"
                data-src="../images/imagogris.png"
              />
            </Row>
          </Row>

          <Row
            className="uk-width-1-5@m uk-width-1-4@s uk-width-1-2"
            style={{
              margin: 0,
              padding: 5,
              alignItems: "flex-start",
              alignContent: "flex-start",
            }}
          >
            <label className="txtfooter">CONTACTO</label>
            {conacts.map((it, i) => {
              return (
                <Contact
                  key={i + " - ContactSection"}
                  image={it.image}
                  text={it.text}
                  action={it.action}
                />
              );
            })}
          </Row>
          <Row
            className="uk-width-1-5@m uk-width-1-4@s uk-width-1-2"
            style={{
              margin: 0,
              padding: 5,
              alignItems: "flex-start",
              alignContent: "flex-start",
            }}
          >
            <label className="txtfooter">OFICINAS</label>
            {offices.map((it, i) => {
              return (
                <Office
                  key={i + " - OfficeSection"}
                  image={it.image}
                  title={it.title}
                  text={it.text}
                  action={it.action}
                />
              );
            })}
          </Row>
          <Row
            className="uk-width-1-5@m uk-width-1-4@s uk-width-1-2 uk-visible@m"
            style={{ alignItems: "flex-start", alignContent: "flex-start" }}
          >
            <img
              style={{ objectFit: "contain" }}
              alt=""
              className="imagenl lazyload uk-width-1-1"
              data-src="../images/imagogris.png"
            />
          </Row>
          <Row
            className="uk-width-1-5@m uk-width-1-4@s uk-width-1-2"
            style={{
              margin: 0,
              padding: 5,
              alignItems: "flex-start",
              alignContent: "flex-start",
            }}
          >
            <label className="txtfooter">NOSOTROS</label>
            {ous.map((it, i) => {
              return (
                <About
                  key={i + " - AboutSection"}
                  image={it.image}
                  title={it.title}
                  text={it.text}
                  action={it.action}
                />
              );
            })}
          </Row>
          <Row
            className="uk-width-1-5@m uk-width-1-4@s uk-width-1-2"
            style={{
              margin: 0,
              padding: 5,
              alignItems: "flex-start",
              alignContent: "flex-start",
            }}
          >
            <label className="txtfooter">ALIANZAS</label>
            {allies.map((it, i) => {
              return (
                <Allay
                  key={i + " - AllaySection"}
                  image={it.image}
                  title={it.title}
                  text={it.text}
                  action={it.action}
                />
              );
            })}
          </Row>

          <Row
            className="centerAll uk-width-1-2@l uk-width-2-3@m uk-width-3-4@s uk-width-1-1 "
            style={{ margin: 0, padding: "10px 0" }}
          >
            {platforms.map((it, i) => {
              return (
                <Platform
                  key={i + " - PlatformSection"}
                  image={it.image}
                  action={it.action}
                />
              );
            })}
          </Row>

          <Row
            style={{ margin: 0, padding: "10px 0" }}
            className="centerAll uk-width-1-1 "
          >
            {socialNetworks.map((it, i) => {
              return (
                <Social
                  key={i + " - SocialSection"}
                  action={it.action}
                  image={it.image}
                  t
                />
              );
            })}
          </Row>
          <Row
            style={{
              margin: 0,
              padding: "10px 0",
              textAlign: "center",
            }}
            className="centerAll uk-width-1-1"
          >
            <label className="normal_text Color4">
              Copyright Kolegia School Manager © 2017 - {moment().format("Y")}.
              Todos los derechos reservados. <br />
              <a href={"/privacy"} className="uk-link-text">
                {" "}
                Aviso de privacidad.
              </a>
              <a href={"/terms/conditions"} className="uk-link-text">
                {" "}
                Términos y Condiciones.
              </a>
              <br />
            </label>
          </Row>
          <Row
            style={{
              margin: 0,
              padding: "1vh 0vh 1vh 0vh",
              textAlign: "center",
            }}
            className="centerAll uk-width-1-1"
          >
            <label className="normal_text">
              <label style={{ color: AppEnv.fourthColor }}>
                <a
                  href={"https://icons8.com"}
                  target="_blank"
                  className="uk-link-heading"
                >
                  <img
                    alt={""}
                    className="lazyload"
                    data-src="https://img.icons8.com/plumpy/24/000000/icons8-logo.png"
                  />
                </a>
              </label>
            </label>
            <label className="normal_text">
              <a
                href={"https://fontawesome.com/"}
                target="_blank"
                className="uk-link-heading"
              >
                <i
                  style={{ color: AppEnv.oxfordDark, fontSize: 20 }}
                  className="fab fa-font-awesome-flag"
                />
              </a>
            </label>
          </Row>
        </Row>
      </Section>

      <Row
        className="centerAll uk-width-1-1"
        style={{
          margin: 0,
          padding: "5px 0",
          backgroundColor: AppEnv.oxfordDark,
        }}
      >
        <label className=" uk-visible@s normal_text Color4">
          Kolegia School Manager & Kolegia Educación Pública
          <img
            alt=""
            style={{ width: "2vw", margin: "0vw 7px 0vw 7px" }}
            className="centerAll lazyload"
            data-src="../images/aprentia.png"
          />
          Son parte de Grupo Aprentia Internacional
        </label>
        <label className=" uk-hidden@s normal_text Color4">
          Kolegia School Manager & Kolegia Educación Pública
          <br />
          <img
            alt=""
            style={{ width: "3vh", margin: "0vw 7px 0vw 7px" }}
            className="centerAll lazyload"
            data-src="../images/aprentia.png"
          />
          <br />
          Son parte de Grupo Aprentia Internacional
        </label>
      </Row>
    </Row>
  );
}
